export default "__VITE_ASSET__C43r4Zl1__"